export function withoutUndefined<T>(
  obj: Record<string, T>
): Record<string, Exclude<T, undefined>> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as Record<string, Exclude<T, undefined>>
}
